import * as chrono from "chrono-node";
const PREFIX = /^\s*\/task\b/i;
const HANDLE = /(^|\s)@([\p{L}\p{N}._-]+)/u;
const VISIBILITY = /(^|\s)#(private|shared|workspace)\b/gi;
const DUE = /\s(?:by|due)\s+(.+)$/i;
export function isTaskCommand(text) {
    return PREFIX.test(text);
}
export function parseTaskCommand(text, now) {
    if (!isTaskCommand(text))
        throw new Error("not a /task command");
    let rest = text.replace(PREFIX, " ");
    let visibility = null;
    rest = rest.replace(VISIBILITY, (_m, lead, tag) => {
        visibility = tag.toLowerCase() === "private" ? "private" : "workspace";
        return lead;
    });
    let assigneeHandle = null;
    const handle = HANDLE.exec(rest);
    if (handle !== null && handle[2] !== undefined) {
        assigneeHandle = handle[2];
        rest = rest.replace(handle[0], handle[1] ?? " ");
    }
    let due = null;
    const dueMatch = DUE.exec(rest);
    if (dueMatch !== null && dueMatch[1] !== undefined) {
        const parsed = chrono.parseDate(dueMatch[1], now, { forwardDate: true });
        if (parsed !== null) {
            due = parsed;
            rest = rest.slice(0, dueMatch.index);
        }
    }
    const title = rest.replace(/\s+/g, " ").trim();
    if (title.length === 0)
        throw new Error("a task needs a title");
    return { title, assigneeHandle, due, visibility };
}
//# sourceMappingURL=task-command.js.map